


































































import {DoorIcon, StairsIcon} from '@/icons';
import {BuildingPartControlState} from '@/model/state/BuildingPartControlState';
import {Component, Prop, Vue} from 'vue-property-decorator';
import RoomControl from './RoomControl.vue';
import {RoomList} from './values';

@Component({
    components: {DoorIcon, RoomControl, StairsIcon},
})
export default class BuildingPartControl extends Vue {
    @Prop({type: Object, required: true})
    public readonly roomLists: { [listId: string]: RoomList };

    @Prop({type: Boolean, required: true})
    public readonly validate: boolean;

    @Prop({type: Object, required: true})
    public readonly state: BuildingPartControlState;

    public get invalid(): boolean {
        if (!this.validate) {
            return false;
        }

        return this.state.value === null
            || Object.values(this.state.rooms).filter(rs => rs.value === null).length !== 0;
    }

    public addRoom(): void {
        this.state.addRoom();
    }

    public cloneRoom(index: string): void {
        this.state.cloneRoom(index);
    }

    public removeRoom(index: string): void {
        this.state.removeRoom(index);
    }

    public hasRooms(): boolean {
        return Object.keys(this.state.rooms).length > 0;
    }

    public isNameInvalid(): boolean {
        return this.invalid && this.state.name === '';
    }

    public updateName(name: string): void {
        this.state.updateName(name);
    }
}
